module.exports = __webpack_public_path__ + "static/media/dropdown.50dbd07d.svg";